import {useMemo} from "react";

import {CHANNELS} from "data/products";
import {useAuth} from "hooks/useAuth";
import {getVisibleChannels} from "utils/roles";
import {useRouteParams, DEFAULT_ROUTE_PATTERNS} from "hooks/useRouteParams";

function makeChannelValue(channelObj) {
  return channelObj ? {label: channelObj.label, value: channelObj.value} : null;
}

export function useChannelFromParams() {
  const {role, featureFlags} = useAuth();
  const params = useRouteParams(DEFAULT_ROUTE_PATTERNS);

  return useMemo(() => {
    const channelParam = params?.channel ?? null;

    const fromParam = CHANNELS.find((c) => c.value === channelParam);
    if (fromParam) return makeChannelValue(fromParam);

    // Role-aware default: first channel visible for this role
    const visible = getVisibleChannels(CHANNELS, role, featureFlags);
    const fallback = visible[0] ?? CHANNELS[0];
    return makeChannelValue(fallback);
  }, [params, role, featureFlags]);
}
